import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=47028531&"
import script from "./Gantt.vue?vue&type=script&lang=ts&"
export * from "./Gantt.vue?vue&type=script&lang=ts&"
import style0 from "./Gantt.vue?vue&type=style&index=0&id=47028531&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports